'use client';
import { useRouter, useSearchParams } from 'next/navigation';
// -------------- icons -------------------- //
import LeftUnion from '@/assets/icons/LeftUnion.svg';
import RightUnion from '@/assets/icons/RightUnion.svg';
import FeedbackSVG from '@/assets/icons/feedbackGold.svg';
import ArrowRightIcon from '@/assets/icons/_TArrowLeft.svg';
import SearchBtnIcon from '@/assets/icons/searchBtn.svg';
// -------------- styling -------------------- //
import { useEffect, useState } from 'react';
import styles from './PageBanner.module.scss';
import TabBar from './TabBar';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import {
  BESTSELLERS_EVENT_NAMES,
  bestSellersBusinessLogger,
} from '@/utils/logger/instance/bestSellersBusinessLogger';
import FeedbackTrigger from '@/components/feedbackTrigger';
import { SourceType } from '@/components/globalFeedbackDrawer/types';

interface PropType {
  bannerDesc: string;
  bannerBackGround: string | null;
  bannerTrack: any;
  sidebarData: any;
  handleFetch: (val: string) => void;
  setCurrentSequenceId: (val: string) => void;
}
const PageBanner = ({
  bannerDesc,
  bannerBackGround,
  sidebarData,
  bannerTrack,
  handleFetch,
  setCurrentSequenceId,
}: PropType) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [bannerVisible, setBannerVisible] = useState<boolean>(true);
  const [isAPP, setIsApp] = useState<boolean>(false);
  // if 'tag' param exist we align to that index else the first one
  const tagIndex = sidebarData.findIndex(
    (item: any) => item.sequenceId === searchParams.get('tag'),
  );
  // Tab selection state control
  const [selected, setSelected] = useState<number>(tagIndex !== -1 ? tagIndex : 0);

  useEffect(() => {
    const container = document.getElementById('main-container');
    if (!container) return;

    const handleScroll = () => {
      if (container.scrollTop > 190) {
        setBannerVisible(false);

        // reset center
      } else {
        setBannerVisible(true);
      }
    };

    container.addEventListener('scroll', handleScroll);

    // Optionally log initial position
    handleScroll();

    if (!bannerBackGround) {
      bestSellersBusinessLogger({
        eventName: BESTSELLERS_EVENT_NAMES.BANNER_IMG_FETCH_FAIL,
        message: {
          error: 'banner server fail',
        },
      });
    }

    // -------------- UA Check -------------------- //
    const { isInJoybuyApp } = uaParse();
    // Check if is IOS OR Android
    if (isInJoybuyApp) {
      setIsApp(true);
    }

    if (!bannerBackGround) {
      bestSellersBusinessLogger({
        eventName: BESTSELLERS_EVENT_NAMES.BANNER_IMG_FETCH_FAIL,
        message: {
          error: 'banner server fail',
        },
      });
    }
    // -------------- return -------------------- //
    return () => {
      container.removeEventListener('scroll', handleScroll);
      setBannerVisible(true);
    };
  }, []);

  const sidebarDataLength = sidebarData.length !== 0;

  return (
    <>
      <div
        className={styles.banner}
        style={{
          ...(bannerBackGround ? { backgroundImage: `url(${bannerBackGround})` } : {}),
        }}
      >
        <div className={styles.topbar}>
          <button onClick={() => router.push('/')}>
            <ArrowRightIcon className={styles.svg} />
          </button>
          <FeedbackTrigger sourceType={SourceType.Marketing_Feedback}>
            <FeedbackSVG style={{ marginLeft: 'auto' }} />
          </FeedbackTrigger>
        </div>
        {/* <div className={styles.title}>
          <LeftUnion />
          <h1></h1>
          <RightUnion />
        </div> */}
        <p>{bannerDesc}</p>
      </div>
      {bannerVisible && sidebarDataLength && (
        <TabBar
          sidebarData={sidebarData}
          bannerTrack={bannerTrack}
          selected={selected}
          setSelected={setSelected}
          handleFetch={handleFetch}
          setCurrentSequenceId={setCurrentSequenceId}
        />
      )}
      {!bannerVisible && !isAPP && (
        <div className={styles.sticky}>
          <div
            className={styles.scrollBanner}
            style={{ visibility: bannerVisible ? 'hidden' : 'visible' }}
          >
            <button onClick={() => router.back()}>
              <ArrowRightIcon className={styles.scrollSvg} />
            </button>
            <span className={styles.scrollTitle}>Bestsellers</span>
          </div>
          {sidebarDataLength && (
            <TabBar
              sidebarData={sidebarData}
              selected={selected}
              bannerTrack={bannerTrack}
              setSelected={setSelected}
              handleFetch={handleFetch}
              setCurrentSequenceId={setCurrentSequenceId}
            />
          )}
        </div>
      )}
    </>
  );
};

export default PageBanner;
